/* Force every <img class="slide__image"> in every slideshow to render
   at its NATURAL aspect ratio. Sets the parent .slide__image-container's
   aspect-ratio from img.naturalWidth/Height once it loads.
   Bypasses any CSS that fights with height: 100% / object-fit: cover. */
(function () {
  if (window.__ashSlideAspectInit) return;
  window.__ashSlideAspectInit = true;

  function fixOne(img) {
    if (!img) return;
    // Don't gate on __ashFixed — re-apply every pass so JIT-resized
    // images (Shopify CDN srcset swap) get refreshed too.
    var apply = function () {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return;
      var ratio = w + ' / ' + h;
      // 1. Clear the HTML width/height attributes — they set an
      //    IMPLICIT aspect-ratio that beats CSS `aspect-ratio: auto`.
      //    Removing them lets the intrinsic ratio (or our inline
      //    aspect-ratio below) drive the box.
      if (img.hasAttribute('width')) img.removeAttribute('width');
      if (img.hasAttribute('height')) img.removeAttribute('height');
      // 2. Walk up every ancestor in the slideshow tree and clear any
      //    fixed height / max-height that would clip the image.
      var c = img.closest('.slide__image-container');
      if (c) {
        c.style.setProperty('aspect-ratio', ratio, 'important');
        c.style.setProperty('height', 'auto', 'important');
        c.style.setProperty('max-height', 'none', 'important');
        c.style.setProperty('min-height', '0', 'important');
        c.style.setProperty('position', 'relative', 'important');
      }
      var slide = img.closest('slideshow-slide');
      if (slide) {
        slide.style.setProperty('height', 'auto', 'important');
        slide.style.setProperty('max-height', 'none', 'important');
        slide.style.setProperty('min-height', '0', 'important');
      }
      var slides = img.closest('slideshow-slides');
      if (slides) {
        slides.style.setProperty('min-height', '0', 'important');
        slides.style.setProperty('max-height', 'none', 'important');
      }
      var comp = img.closest('slideshow-component');
      if (comp) {
        comp.style.setProperty('--slide-min-height', '0', 'important');
        comp.style.setProperty('--slide-min-height-desktop', '0', 'important');
        comp.style.setProperty('min-height', '0', 'important');
        comp.style.setProperty('max-height', 'none', 'important');
      }
      // 3. Set the image's own dimensions inline. Inline beats CSS,
      //    !important pushes even harder.
      img.style.setProperty('aspect-ratio', ratio, 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', 'auto', 'important');
      img.style.setProperty('max-height', 'none', 'important');
      img.style.setProperty('min-height', '0', 'important');
      img.style.setProperty('object-fit', 'initial', 'important');
    };
    if (img.complete && img.naturalWidth) {
      apply();
    } else {
      img.addEventListener('load', apply, { once: true });
    }
  }

  function fixAll(root) {
    (root || document).querySelectorAll('slideshow-slide .slide__image').forEach(fixOne);
  }

  /* Aggressive retries: slides lazy-load via srcset and our first
     pass may run before naturalWidth is populated. */
  function runAndRetry() {
    fixAll();
    [50, 250, 750, 1500, 3000].forEach(function (delay) {
      setTimeout(function () { fixAll(); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAndRetry);
  } else {
    runAndRetry();
  }
  window.addEventListener('load', function () { fixAll(); });
  window.addEventListener('resize', function () { fixAll(); }, { passive: true });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      if (!added) continue;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (
          (n.matches && n.matches('slideshow-slide .slide__image')) ||
          (n.querySelector && n.querySelector && n.querySelector('slideshow-slide .slide__image'))
        )) {
          fixAll(n.parentNode || document);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
